var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, 1);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/succ.js
// module id = 895
// module chunks = 1